import type {BioIconProps} from './common-types'

export function IconChevronRight({fill = '#676879', ...attributes}: BioIconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.47123 6.62955L9.1 7.00078L9.47123 7.37201C9.67626 7.16699 9.67626 6.83458 9.47123 6.62955ZM8.35754 7.00078L3.82877 11.5296C3.62374 11.7346 3.62374 12.067 3.82877 12.272C4.03379 12.477 4.36621 12.477 4.57123 12.272L9.47123 7.37201C9.47125 7.37199 9.47123 7.37201 9.1 7.00078C9.47123 6.62955 9.47125 6.62957 9.47123 6.62955L4.57123 1.72955C4.36621 1.52453 4.03379 1.52453 3.82877 1.72955C3.62374 1.93458 3.62374 2.26699 3.82877 2.47201L8.35754 7.00078Z"
      />
    </svg>
  )
}
